/**
 * Scenarios Container - Unified interface for scenario management
 */
import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
} from '@mui/material';
import ScenarioBuilder from './ScenarioBuilder';
import ScenarioComparison from './ScenarioComparison';
import TabPanel from '../Common/TabPanel';

const ScenariosContainer: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      {/* Page title */}
      <Box sx={{ mb: '20px' }}>
        <Typography sx={{ fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-text-primary)', fontFamily: 'var(--font-heading)' }}>
          What-If Scenario Analysis
        </Typography>
        <Typography sx={{ fontSize: 'var(--text-base)', color: 'var(--color-text-muted)', mt: 0.5, fontFamily: 'var(--font-body)' }}>
          Simulate different scenarios and compare their impact on inventory and revenue
        </Typography>
      </Box>

      {/* Tab navigation */}
      <Box sx={{ borderBottom: '1px solid var(--color-border)', mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Scenario Builder" />
          <Tab label="Scenario Compare" />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box className="page-enter">
        <TabPanel value={tabValue} index={0}>
          <ScenarioBuilder />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ScenarioComparison />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ScenariosContainer;
